import { projectContext } from '@/layouts/MainLayout'
import { filterMembersByGroupName, getProjectMembers } from '@/services/member/member'
import { useRequest } from 'ahooks'
import { memo, useContext, useMemo } from 'react'
import ProjectMemberTable from '../components/ProjectMemberTable'
import { selectUser } from '@/store/user/user.slice'
import { useSelector } from 'react-redux'

export default memo(function ProjectOutsideCollaborators() {
  const { projectId, projectData } = useContext(projectContext)
  const { data = [], run: getMembers, loading } = useRequest(() =>
    getProjectMembers(Number(projectId))
  )
  const user = useSelector(selectUser)
  const me = useMemo(() => {
    return data.find(item => item.email === user.userInfo?.email)
  }, [data, user])

  const members = filterMembersByGroupName(data, 'ADDED_MEMBER')

  return <ProjectMemberTable me={me} members={members} reload={getMembers} loading={loading} project={projectData} />
})
